import React from 'react'
import styled from '@emotion/styled'
import { withTranslation } from 'react-i18next'
import splitTitleBody from '../../helpers/splitTitleBody'

const Wrapper = styled.div`
  flex: 1;
`

// const ItemsList = styled.tbody`
//   margin: 1.5em -2.5em;
//   padding: 1em 2.5em;
// `

function Main({ invoice, invoiceSettings, t, formatMoney, page, numPages }) {
  const noteText = invoice.note || ''
  const { body: noteBody, title: noteTitle } = splitTitleBody(noteText)
  const firstPage = page === 0
  const lastPage = page === numPages - 1
  const note = (
    <tr className='note'>
      <td>
        {noteTitle && <p className='label'>{noteTitle}</p>}
        <p>{noteBody}</p>
      </td>
    </tr>
  )
  let lines = invoice.Lines || []
  // lines = [...lines, ...lines, ...lines]
  const pageSize = invoiceSettings.maxLinesPerPage;
  // lines = lines.slice(page * pageSize, page * pageSize + pageSize)

  const itemComponents = lines.map(
    (
      { name, description, vatCode, vatPercentage, price, amount, quantity },
      index
    ) => {
      return (
        <tr className='invoice-line' key={index}>
          <td className='line-description'>
            {name && <div style={{ fontWeight: 'normal' }}>{name}</div>}
            <div style={{ opacity: name ? 0.55 : 1 }}>{description}</div>
          </td>
          <td>{quantity && Number(quantity)}</td>
          <td>{formatMoney(price)}</td>
          <td>
            <span>{vatPercentage || 0}%</span>
          </td>
          <td>
            <span>{formatMoney(amount)}</span>
          </td>
        </tr>
      )
    }
  )

  const colspan = 5 - 3

  const {
    subtotalAmount,
    totalVatAmounts,
    totalVatAmount,
    totalAmount
  } = invoice
  return (
    <Wrapper>
      <table className='invoice-table'>
        <colgroup>
          <col className='line-description' />
          <col className='line-quantity' />
          <col className='line-price' />
          <col className='line-vat-percentage' />
          <col className='line-amount' />
        </colgroup>
        <thead>
          <tr>
            <th>{t('description')}</th>
            <th>{t('quantity')}</th>
            <th>{t('price')}</th>
            <th>{t('vat')}</th>
            <th>{t('amount')}</th>
          </tr>
        </thead>
        <tbody className='invoice-lines'>{itemComponents}</tbody>
        {lastPage && (
          <tbody className='invoice-totals'>
          {note}
          <tr className='subtotal-amount'>
            <td colSpan={colspan} />
            <td colSpan={1}>
              <div>{t('subtotal')}</div>
            </td>
            <td>
              <div>€</div>
            </td>
            <td colSpan={1}>
              <div>{formatMoney(subtotalAmount)}</div>
            </td>
          </tr>
          {totalVatAmounts &&
            totalVatAmounts.map(({ vatCodeId, displayName, amount }) => (
              <tr className='total-vat-amount' key={vatCodeId}>
                <td colSpan={colspan} />
                <td colSpan={1} style={{ fontSize: '0.9em' }}>
                  <div>
                    {t('vat')} {displayName}
                  </div>
                </td>
                <td>
                  <div>€</div>
                </td>
                <td colSpan={1}>
                  <div>{formatMoney(amount)}</div>
                </td>
              </tr>
            ))}

          <tr className='total-amount'>
            <td colSpan={colspan} />
            <td colSpan={1}>
              <div>{t('total')}</div>
            </td>
            <td>
              <div>€</div>
            </td>
            <td colSpan={1}>
              <div>{formatMoney(totalAmount)}</div>
            </td>
          </tr>
        </tbody>
        )}
        {/*<tfoot><tr><td><div className="footer-height">sdfkaskdfaskdf</div></td></tr></tfoot>*/}
      </table>
    </Wrapper>
  )
}
export default withTranslation()(Main)
